import SkeletonRectangle from './SkeletonRectangle';
export default SkeletonRectangle;
